import React from 'react';
import { useState } from 'react';
import { Box} from '@mui/material';
import { Container, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
// import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
// import Select from '@mui/material/Select';


import { stateValuesDos } from '../../Utils/Utils';

export default function AddCompanyForm(props) {
  const [inputStateValue, setInputStateValue] = useState('');
  const [stateValue, setStateValue] = useState(null);

  return (
    <Box>
      <Container>
        <form id="submitNewCompanyForm" onSubmit={e => props.submitNewHqCompany(e)}>
        {/*  */}
          <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                  <h4 style={{textAlign:'center'}}>Add A New {props.addWhatCompanyTitle} Headquarter</h4>
              </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard" error={props.errorValidator.hq_company_name ? true:false}>
                    <InputLabel htmlFor="name-input">{props.addWhatCompanyTitle} Name</InputLabel>
                    <Input 
                      id="name-input"
                      type={'text'} 
                      value={props.hqCompanyObject.hq_company_name}
                      onChange={(e)=>{props.handleNameChange(e);
                        }}/>
                        <FormHelperText id="usernamefield-error-text"
                          sx={{
                              display:props.errorValidator.hq_company_name ? "block":"none",
                          }}
                                            
                          >Invalid {props.addWhatCompanyTitle} Name.</FormHelperText>
                </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6} md={6} lg={6}>
                    <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                        <InputLabel htmlFor="hq-email-input">Headquarter Email</InputLabel>
                        <Input 
                        id="hq-email-input" 
                        type={'text'} 
                        value={props.hqCompanyObject.hq_email} 
                        onChange={e=>{
                          props.handleEmailChange(e)}
                          }/>
                    </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
                <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                    <InputLabel htmlFor="hq-phone-input">Headquarter Phone</InputLabel>
                    <Input 
                    id="hq-phone-input" 
                    type={'text'} 
                    value={props.hqCompanyObject.hq_phone} 
                    onChange={e=>{props.handlePhoneChange(e)}}/>
                </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6} md={6} lg={6} id="bank_address">
              <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                  <InputLabel htmlFor="address-input">Address</InputLabel>
                  <Input 
                    id="address-input" 
                    type={'text'}
                    value={props.hqCompanyObject.hq_company_address.address}
                    onChange={e=>{props.handleAddressChange(e)}}/>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} id="bank_address_two">
                <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                    <InputLabel htmlFor="address-two-input">Address 2</InputLabel>
                    <Input 
                      id="address-two-input" 
                      type={'text'} 
                      value={props.hqCompanyObject.hq_company_address.address_two}
                      onChange={e=>{props.handleAddressTwoChange(e)}}/>
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4}>
                <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                    <InputLabel htmlFor="address-city-input">City</InputLabel>
                    <Input 
                      id="address-city-input" 
                      type={'text'} 
                      value={props.hqCompanyObject.hq_company_address.city} 
                      onChange={e=>{props.handleCityChange(e)}}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4}>
                <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                  <Autocomplete
                  id="bank-state-input"
                  value={stateValue}
                  options={stateValuesDos}
                  getOptionLabel={(option) => option.index || ""}
                  renderOption={(props, option) => (
                      <Box component="li" {...props}>
                      {option.index} - {option.fullName}
                      </Box>
                  )}
                  isOptionEqualToValue={(option, value) => option.index === value.index}
                  onChange={(event, newValue) => {
                      setStateValue(newValue); // new value set for the autocomplete
                      props.handleStateChange(newValue); // value set in inspectionObject

                  }}
                  inputValue={inputStateValue}
                  onInputChange={(event, newInputValue) => {
                    setInputStateValue(newInputValue);
                  }}
                  renderInput={(params) => (
                  <TextField {...params} label="State" variant="standard" />
                  )}
                  />
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4}>
                <FormControl fullWidth={true} sx={{ m: 1 }} variant="standard">
                    <InputLabel htmlFor="address-zip-input">Zip</InputLabel>
                    <Input id="address-zip-input" 
                    value={props.hqCompanyObject.hq_company_address.zip} type={'text'} 
                    onChange={e=>{props.handleZipChange(e)}}/>
                </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl sx={{ m: 1 }} variant="standard">
                <Button variant='contained' type="submit" >Submit</Button>
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </Container>
    </Box>
  )
}
